'use strict';
module.exports = function toFastProperties(obj) {
	function f() {}
	f.prototype = obj;
	new f();
	return;
	eval(obj);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/to-fast-properties/index.js
 ** module id = 245
 ** module chunks = 0
 **/